import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchAdminEvaluadores = ({ id }) => {
  const [response, setResponse] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios.get(`/desempeno_admin/${id}/`)
        setResponse(result.data)
      } catch (err) {
        setError(err.response?.data || err.message || 'Error al cargar los datos')
      } finally {
        setLoading(false)
      }
    }
    if (id) {
      fetchData()
    }
  }, [id])

  return { response, loading, error }
}

export default useFetchAdminEvaluadores
